import * as $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slick-targeted-theme.scss';

import { replaceTags, RegexPatterns, resolveUrls } from '../helpers/template-utils';
import * as Utils from '../helpers/utils';

export interface Config {
  wrapperEl: Element;
  componentCls?: string;
  componentNavCls?: string;
  onComponentMount?: Function;
  data: {
    currencies: {
      [index: string]: any;
    },
    globalProperties?: {
      [index: string]: any;
    },
    resolverUrl?: string,
    items?: Array<string>
  };
  slickOptions?: JQuerySlickOptions;
  thumbnailSlickOptions?: JQuerySlickOptions;
}

/*
  new TargetedNewsCarousel({
    wrapperEl: document.querySelector('scrm-content'),
    data: {
      resolverUrl: 'https://res.ps.im/v1/be/4/en/ie/_/_/_/',
      items: [
        '<div><img class="" src="//starscrm.rationalcdn.com/starscrm/79dao3p3o1ne0sf7ha/en/v1/1400x280_200pct_fdb.jpg"></div>',
        '<div><img class="" src="//starscrm.rationalcdn.com/starscrm/79dao3p3o1ne0sf7ha/en/v1/1400x280_200pct_fdb.jpg"></div>',
        '<div><img class="" src="//starscrm.rationalcdn.com/starscrm/79dao3p3o1ne0sf7ha/en/v1/1400x280_200pct_fdb.jpg"></div>',
      ]
    },
    slickOptions: {
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      lazyLoad: 'progressive',
      speed: 500,
      fade: true,
      cssEase: 'linear'
    },
    thumbnailSlickOptions: {
      slidesToShow: 4,
      autoplay: false,
      focusOnSelect: true,
      asNavFor: '.scrm-slider'
    }
  });
*/
// For later Consideration - refactor and extend from base carousel
export class TargetedNewsCarousel {
  compId: string;
  primarySlider: JQuery;
  thumbnailSlider: JQuery;

  constructor(private config: Config) {
    this.compId = Utils.uniqueId();
    this.initialize();
  }

  initialize() {
    const { items, resolverUrl, globalProperties, currencies } = this.config.data;
    if (items && items.length > 0) {
      window.addEventListener('scrmtargeteddestroy', this.onDestroy);

      const packages: Array<string> = items
        .map(item => resolveUrls(resolverUrl, item))
        .map(item => replaceTags(RegexPatterns.currencies, currencies, item))
        .map(item => replaceTags(RegexPatterns.templateTags, globalProperties, item));

      this.render(packages);
      Utils.addScrmClickEventsToChildren(this.primarySlider);
    }
  }

  render(packages: Array<string>) {
    // create a parent node for the primary and thumbnail slider
    let parentNode = $('<div></div>', { class: 'scrm-targeted-theme' });
    // create nodes for the primary and thumbnail slider
    let primarySliderNode = $('<div></div>', { class: `${this.getComponentCls()} ${this.getComponentIdCls()}` });
    let thumbnailSliderNode = $('<div></div>', { class: `${this.getComponentNavCls()} ${this.getComponentNavIdCls()}` });

    // grab all script nodes and convert to script nodes
    const scriptNodes = Utils.getScriptNodesFromPackages(packages);
    packages.forEach(item => primarySliderNode.append(`<div>${item}</div>`));

    // add thumbnails if we have more than 1 content item
    if (packages.length > 1) {
      packages.forEach(item => thumbnailSliderNode.append(`<div>${item}</div>`));
    }

    Utils.removeScriptNodes(primarySliderNode);
    Utils.removeScriptNodes(thumbnailSliderNode);

    // add the sliders to the parent
    primarySliderNode.appendTo(parentNode);
    thumbnailSliderNode.appendTo(parentNode);

    // add script nodes to the parent
    parentNode.append(scriptNodes);

    // add the parent node sliders to the DOM
    parentNode.appendTo(this.config.wrapperEl);

    // slick both
    primarySliderNode.slick({ ...this.config.slickOptions, asNavFor: Utils.toCssClass(this.getComponentNavIdCls()) });
    thumbnailSliderNode.slick({ ...this.config.thumbnailSlickOptions, asNavFor: Utils.toCssClass(this.getComponentIdCls()) });

    // disable thumbnail default click behaviour
    thumbnailSliderNode.find('.slick-slide').on('click', (e) => { e.preventDefault(); });

    this.primarySlider = primarySliderNode;
    this.thumbnailSlider = thumbnailSliderNode;

    if (this.config.onComponentMount) {
      this.config.onComponentMount();
    }
  }

  onDestroy = () => {
    if (this.primarySlider) {
      this.primarySlider.slick('unslick');
      this.primarySlider = null;
    }

    if (this.thumbnailSlider) {
      this.thumbnailSlider.slick('unslick');
      this.thumbnailSlider = null;
    }

    if (this.config.wrapperEl) {
      $(this.config.wrapperEl).remove();
      this.config.wrapperEl = null;
    }

    window.removeEventListener('scrmtargeteddestroy', this.onDestroy);
  }

  getComponentIdCls() {
    return `${this.getComponentCls()}-${this.compId}`;
  }

  getComponentNavIdCls() {
    return `${this.getComponentNavCls()}-${this.compId}`;
  }

  getComponentCls() {
    return this.config.componentCls || 'scrm-slider';
  }

  getComponentNavCls() {
    return this.config.componentNavCls || 'scrm-slider-nav';
  }
}




// WEBPACK FOOTER //
// ./src/components/targeted-carousel.ts